import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import dropdownService from './dropdownService';

export const createMasterEntryType = createAsyncThunk(
	'/createMasterEntry',
	async ({ masterValue, parentId }, thunkAPI) => {
		try {
			const response = await dropdownService.createMasterEntry({
				masterValue,
				parentId,
			});
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getMasterTypesData = createAsyncThunk('/getMasterTypesData', async (thunkAPI) => {
	try {
		const response = await dropdownService.getAllMasterTypes();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const getAllSuppliersData = createAsyncThunk('/getAllSuppliersData', async (thunkAPI) => {
	try {
		const response = await dropdownService.getAllSupplier();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const getGstStateCodeData = createAsyncThunk('/getGstStateCodeData', async (thunkAPI) => {
	try {
		const response = await dropdownService.getGstStateCodes();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});
export const getGstPercentageData = createAsyncThunk('/getGstPercentageData', async (thunkAPI) => {
	try {
		const response = await dropdownService.getGstPercentage();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const getMasterEntryByIdData = createAsyncThunk(
	'/getMasterEntryByIdData',
	async ({ id }, thunkAPI) => {
		try {
			const response = await dropdownService.getMasterEntryById({ id });
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getAllProductLotsData = createAsyncThunk(
	'/getAllProductLotsData',

	async (id, thunkAPI) => {
		try {
			const response = await dropdownService.getAllProductsLot(id);
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getBrandsData = createAsyncThunk(
	'/getBrandsData',

	async (id, thunkAPI) => {
		try {
			const response = await dropdownService.getBrands(id);
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getDesignNumberData = createAsyncThunk(
	'/getDesignNumberData',

	async (data, thunkAPI) => {
		try {
			const response = await dropdownService.getDesignNumber(data);
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getAllSizesData = createAsyncThunk(
	'/getAllSizesData',

	async (data, thunkAPI) => {
		try {
			const response = await dropdownService.getAllSizes(data);
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getAllSizeGroupsData = createAsyncThunk('/getAllSizeGroupsData', async (thunkAPI) => {
	try {
		const response = await dropdownService.getAllSizeGroups();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const getColorSlotData = createAsyncThunk(
	'/getColorSlotData',

	async (data, thunkAPI) => {
		try {
			const response = await dropdownService.getColorSlots(data);
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getSizeSlotData = createAsyncThunk(
	'/getSizeSlotData',

	async (data, thunkAPI) => {
		try {
			const response = await dropdownService.getSizeSlots(data);
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getAllModulesDropdownData = createAsyncThunk(
	'/getAllModulesDropdownData',

	async (data, thunkAPI) => {
		try {
			const response = await dropdownService.getAllModulesDropdowns(data);
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getArticleCodesByBrand = createAsyncThunk(
	'/getArticleCodesByBrand',

	async (data, thunkAPI) => {
		try {
			const response = await dropdownService.getArticleCodes(data);
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);

const initialState = {
	MasterEntry: [],
	AllMasterTypes: [],
	AllMasterEntry: [],
	AllSuppliers: [],
	AllStates: [],
	AllMasterEntryById: {},
	AllGSTPercentage: [],
	GetAllProductsLot: [],
	GetBrands: [],
	GetDesignNumbers: [],
	GetAllSizes: [],
	GetAllSizeGroups: [],
	GetColorSlot: [],
	GetSizeSlot: [],
	GetAllModules: [],
	GetArticleCodeByBrand: [],
	isError: false,
	isLoading: false,
	isSuccess: false,
	message: '',
};

const dropdownSlice = createSlice({
	name: 'dropdowns',
	initialState,
	reducers: {
		reset: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.isSuccess = false;
			state.message = '';
		},
		resetMessage: (state) => {
			state.message = '';
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(createMasterEntryType.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(createMasterEntryType.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.MasterEntry = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(createMasterEntryType.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getMasterTypesData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getMasterTypesData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.AllMasterTypes = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getMasterTypesData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getAllSuppliersData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getAllSuppliersData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.AllSuppliers = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getAllSuppliersData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getGstStateCodeData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getGstStateCodeData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.AllStates = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getGstStateCodeData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getGstPercentageData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getGstPercentageData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.AllGSTPercentage = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getGstPercentageData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getMasterEntryByIdData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getMasterEntryByIdData.fulfilled, (state, action) => {
				const id = action.meta.arg.id; // get the ID from thunk arg
				state.isLoading = false;
				state.isError = false;
				state.isSuccess = true;
				state.AllMasterEntryById[id] = action.payload.data; // store per ID
			})
			.addCase(getMasterEntryByIdData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getAllProductLotsData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getAllProductLotsData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.GetAllProductsLot = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getAllProductLotsData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getBrandsData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getBrandsData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.GetBrands = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getBrandsData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getDesignNumberData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getDesignNumberData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.GetDesignNumbers = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getDesignNumberData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getAllSizesData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getAllSizesData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.GetAllSizes = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getAllSizesData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getColorSlotData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getColorSlotData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.GetColorSlot = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getColorSlotData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getSizeSlotData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getSizeSlotData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.GetSizeSlot = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getSizeSlotData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getAllModulesDropdownData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getAllModulesDropdownData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.GetAllModules = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getAllModulesDropdownData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getArticleCodesByBrand.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getArticleCodesByBrand.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.GetArticleCodeByBrand = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getArticleCodesByBrand.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			})
			.addCase(getAllSizeGroupsData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getAllSizeGroupsData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isError = false;
				state.GetAllSizeGroups = action.payload.data;
				state.isSuccess = true;
			})
			.addCase(getAllSizeGroupsData.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.isSuccess = false;
				state.message = action.payload;
			});
	},
});

export const { reset, resetMessage } = dropdownSlice.actions;
export default dropdownSlice.reducer;
